import React, {Component} from 'react';
import {Table} from 'semantic-ui-react';
import {connect} from "react-redux";

import LoadingRow from "../extras/LoadingRow";
import NoData from "../extras/NoData";
import SaleItemData from "../../data/SaleItemData";
import {listProductsSale, updateQuantity} from "../../actions/ProductsSaleActions";
import ProductSaleRow from "./ProductSaleRow";

class ProductsSale extends Component {
    constructor(props){
        super(props);
        this.state = {
            sale: props.sale,
            loading: true
        };

        this.initialFetch = this.initialFetch.bind(this);
    }

    async initialFetch() {
        let products_sale = await SaleItemData.getList(this.state.sale.id);
        this.props.listProductsSale(products_sale);
        this.setState({loading: false});
    };

    componentDidMount(){
        this.initialFetch();
    };

    render() {

        return (
            <Table compact>
                <Table.Header>
                    <Table.Row>
                        {this.state.sale.state === 1 ? <Table.HeaderCell>Cantidad</Table.HeaderCell>:null}
                        <Table.HeaderCell>Producto</Table.HeaderCell>
                        <Table.HeaderCell>V. Unitario</Table.HeaderCell>
                        <Table.HeaderCell>Impuesto</Table.HeaderCell>
                        <Table.HeaderCell>Subtotal</Table.HeaderCell>
                        <Table.HeaderCell/>
                    </Table.Row>
                </Table.Header>
                <Table.Body>
                    {
                        this.state.loading ?
                            <LoadingRow colSpan={6}/> :
                            this.props.products_sale.length > 0 ?
                                this.props.products_sale.map(function (product_sale) {
                                    return (
                                        <ProductSaleRow
                                            {...product_sale}
                                            key={product_sale.id}
                                            sale_id={this.props.sale.id}
                                            order_state={this.state.sale.state}
                                        />
                                    )
                                }, this) : <NoData colSpan={6}/>
                    }
                </Table.Body>

            </Table>
        );
    }
}

function mapDispatchToProps(dispatch){
    return {
        listProductsSale(products_sale) {
            dispatch(listProductsSale(products_sale));
        },
        updateQuantity(product) {
            dispatch(updateQuantity(product));
        }
    }
}

function mapStateToProps(state){
    return{
        products_sale: state.get('products_sale'),
    };
}


export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ProductsSale)



// WEBPACK FOOTER //
// ./src/components/sale/ProductsSale.js